export default __webpack_public_path__ + "static/media/36I-102795_-15934_0.1c348632.jpg";